import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@asset-metrix/portal-ui';

import styles from './bulk-delete-confirmation.module.scss';

export type BulkDeleteConfirmationProps = {
  rowCount?: number;
  onApply: () => void;
  onClose: () => void;
  opened: boolean;
};

export function BulkDeleteConfirmation({
  rowCount,
  onApply,
  onClose,
  opened,
}: BulkDeleteConfirmationProps) {
  const { t } = useTranslation();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      modalType="action"
      title={t('app.table.deleteConfirmation.title')}
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            {t('app.table.deleteConfirmation.cancel')}
          </Button>
          <Button variant="primary" onClick={onApply}>
            {t('app.table.deleteConfirmation.apply')}
          </Button>
        </>
      }
    >
      <div className={styles['content']}>
        {t('app.table.deleteConfirmation.message', { count: rowCount })}
      </div>
    </Modal>
  );
}
